import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getExpertProfile } from '../../../Redux/expertSlice'
import { 
  FiStar, 
  FiUsers, 
  FiClock, 
  FiBookOpen, 
  FiBook, 
  FiVideo, 
  FiMail, 
  FiAward, 
  FiCalendar, 
  FiDollarSign,
  FiX,
  FiUser,
  FiBriefcase,
  FiTrendingUp,
  FiCheckCircle,
  FiPlayCircle,
  FiImage,
  FiInfo,
  FiBarChart2,
  FiHeart,
  FiEye,
  FiShare2,
  FiDownload,
  FiMessageCircle,
  FiTag,
  FiCreditCard,
  FiGlobe,
  FiShield,
  FiHash
} from "react-icons/fi";
import { 
  MdOutlineClose, 
  MdOutlinePerson,
  MdOutlineEmail,
  MdOutlineCalendarToday,
  MdOutlineAccessTime,
  MdOutlineAttachMoney,
  MdOutlineStar,
  MdOutlinePeople,
  MdOutlineBook,
  MdOutlineVideoLibrary,
  MdOutlinePlayCircle,
  MdOutlineInfo,
  MdOutlineBarChart,
  MdOutlineFavorite,
  MdOutlineVisibility,
  MdOutlineShare,
  MdOutlineDownload,
  MdOutlineMessage,
  MdOutlineCategory,
  MdOutlineAccountBalance,
  MdOutlinePayment
} from "react-icons/md";
import { IoPersonOutline, IoMailOutline, IoCalendarOutline, IoTimeOutline, IoCashOutline, IoStarOutline, IoPeopleOutline, IoBookOutline, IoVideocamOutline, IoPlayCircleOutline, IoInformationCircleOutline, IoBarChartOutline } from "react-icons/io5";
import { RxCross2 } from 'react-icons/rx'
import moment from 'moment'

const ViewModal = ({ isOpen, onCancel, ViewModalData }) => {
  const dispatch = useDispatch()
  const expertProfile = useSelector(state => state?.expertSlice?.getExpertProfile)

  useEffect(() => {
    if (ViewModalData?._id) {
      dispatch(getExpertProfile({ expertId: ViewModalData._id }))
    }
  }, [ViewModalData?._id, dispatch])

  const courses = expertProfile?.courses || []
  const batches = expertProfile?.batches || []
  const books = expertProfile?.books || []
  const [activeVideo, setActiveVideo] = useState(null)

  if (!isOpen) return null

  const formatDate = (dateString) => {
    return moment(dateString).format('MMM D, YYYY')
  }

  const formatTime = (timeString) => {
    return moment(timeString).format('h:mm A')
  }

  const renderVideoModal = () => {
    if (!activeVideo) return null

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-200">
        <div className="relative w-full max-w-4xl animate-in zoom-in-95 duration-200">
          <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-gray-900 to-black rounded-t-xl">
            <div className="flex items-center gap-3">
              <FiPlayCircle className="w-5 h-5 text-white" />
              <h3 className="text-lg font-semibold text-white truncate">{activeVideo?.title}</h3>
            </div>
            <button
              onClick={() => setActiveVideo(null)}
              className="p-2 text-white/70 hover:text-white hover:bg-white/20 rounded-lg transition-all duration-200"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>
          <div className="p-2 bg-black rounded-b-xl">
            <video
              controls
              autoPlay
              className="w-full h-[60vh] object-contain rounded-lg"
              src={activeVideo?.videoUrl}
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    )
  }

  const renderCard = (item, type) => {
    const isBook = type === 'book'
    const isBatch = type === 'batch'
    const isCourse = type === 'course'

    return (
      <div key={item?._id} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg hover:border-[#715EFE]/30 transition-all duration-300 group">
        <div
          className="relative cursor-pointer overflow-hidden bg-gray-100"
          onClick={() => setActiveVideo({
            title: item?.title,
            videoUrl: item?.videoUrl
          })}
        >
          <img
            src={item?.thumbUrl || "/Img/library.png"}
            alt={item?.title}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
            onError={(e) => e.target.src = "/Img/library.png"}
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/40">
            <div className="flex items-center justify-center w-14 h-14 bg-white/90 rounded-full shadow-lg hover:scale-110 transition-transform duration-200">
              <FiPlayCircle className="w-7 h-7 text-[#715EFE]" />
            </div>
          </div>
          {item?.isPaid !== undefined && (
            <span className={`absolute top-3 right-3 px-3 py-1 text-xs font-semibold rounded-full shadow-md ${
              item?.isPaid ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-700'
            }`}>
              {item?.isPaid ? `$${item?.price}` : 'Free'}
            </span>
          )}
          {isBook && (
            <span className="absolute top-3 right-3 px-3 py-1 text-xs font-semibold text-blue-700 bg-blue-100 rounded-full shadow-md">
              ${item?.pricePerHour}/hr
            </span>
          )}
        </div>

        <div className="p-4">
          <h4 className="text-base font-semibold text-gray-800 truncate">{item?.title}</h4>
          {item?.desc && (
            <p className="mt-1 text-sm text-gray-600 line-clamp-2">{item?.desc}</p>
          )}

          {isBatch && item?.availability?.length > 0 && (
            <div className="mt-3 pt-3 border-t border-gray-100">
              <div className="flex items-center gap-1.5 text-xs text-gray-500">
                <FiCalendar className="w-3.5 h-3.5" />
                <span className="font-medium">Upcoming Sessions</span>
              </div>
              <div className="mt-1.5 space-y-1.5">
                {item?.availability.slice(0, 2).map((avail, index) => (
                  <div key={index} className="text-xs">
                    <span className="font-medium text-gray-700">{formatDate(avail?.date)}</span>
                    <div className="flex flex-wrap gap-1 mt-0.5">
                      {avail?.slots.map((slot, slotIndex) => (
                        <span key={slotIndex} className="px-2 py-0.5 bg-gray-100 rounded text-gray-600">
                          {formatTime(slot?.startTime)} - {formatTime(slot?.endTime)}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
                {item?.availability.length > 2 && (
                  <p className="text-xs text-[#715EFE]">+{item?.availability.length - 2} more dates</p>
                )}
              </div>
            </div>
          )}

          {isBook && item?.slots?.length > 0 && (
            <div className="mt-3 pt-3 border-t border-gray-100">
              <div className="flex items-center gap-1.5 text-xs text-gray-500">
                <FiCalendar className="w-3.5 h-3.5" />
                <span className="font-medium">Available Slots</span>
              </div>
              <div className="mt-1.5 space-y-1.5">
                {item?.slots.slice(0, 2).map((slotGroup, index) => (
                  <div key={index} className="text-xs">
                    <span className="font-medium text-gray-700">{formatDate(slotGroup?.date)}</span>
                    <div className="flex flex-wrap gap-1 mt-0.5">
                      {slotGroup?.slots.slice(0, 3).map((slot, slotIndex) => (
                        <span
                          key={slotIndex}
                          className={`px-2 py-0.5 rounded text-xs ${
                            slot?.status === 'booked'
                              ? 'bg-rose-100 text-rose-700'
                              : 'bg-emerald-100 text-emerald-700'
                          }`}
                        >
                          {formatTime(slot?.startTime)} - {formatTime(slot?.endTime)}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="relative w-full max-w-5xl bg-white shadow-2xl rounded-2xl animate-in zoom-in-95 duration-200 max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="relative p-6 text-white bg-gradient-to-r from-[#855DF6] to-[#715EFE] rounded-t-2xl flex-shrink-0">
          <button
            className="absolute p-2 text-white/70 hover:text-white hover:bg-white/20 rounded-lg transition-all duration-200 top-4 right-4"
            onClick={onCancel}
            aria-label="Close"
          >
            <FiX className="w-5 h-5" />
          </button>
          
          <div className="flex flex-col gap-4 md:flex-row md:items-center">
            <div className="relative flex-shrink-0">
              <img
                className="w-20 h-20 rounded-full border-4 border-white/50 object-cover shadow-lg mx-auto md:mx-0"
                src={ViewModalData?.profileImage || '/Img/user.png'}
                alt={`${ViewModalData?.fullName || 'Expert'} Profile`}
                onError={(e) => e.target.src = "/Img/user.png"}
              />
              {expertProfile?.isFollow && (
                <div className="absolute bottom-0 right-0 w-6 h-6 bg-emerald-500 rounded-full border-2 border-white flex items-center justify-center">
                  <FiCheckCircle className="w-3.5 h-3.5 text-white" />
                </div>
              )}
            </div>
            <div className="text-center md:text-left">
              <h2 className="text-2xl font-bold">{ViewModalData?.fullName}</h2>
              <p className="text-white/80 font-medium">{ViewModalData?.profile}</p>
              {expertProfile?.bio && (
                <p className="mt-1 text-sm text-white/70 max-w-md">{expertProfile?.bio}</p>
              )}
              <div className="flex items-center gap-2 mt-2">
                <div className="flex items-center gap-1.5 px-3 py-1 bg-white/20 rounded-full">
                  <FiTag className="w-3.5 h-3.5 text-white/80" />
                  <span className="text-sm text-white/90 capitalize">{expertProfile?.skill || 'No skills listed'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl p-4 border border-blue-100">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-500/10 rounded-lg">
                  <FiUsers className="w-4 h-4 text-blue-600" />
                </div>
                <div>
                  <p className="text-xs font-medium text-blue-600">Followers</p>
                  <p className="text-lg font-bold text-gray-800">{expertProfile?.followers || 0}</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 rounded-xl p-4 border border-amber-100">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-amber-500/10 rounded-lg">
                  <FiStar className="w-4 h-4 text-amber-600" />
                </div>
                <div>
                  <p className="text-xs font-medium text-amber-600">Rating</p>
                  <p className="text-lg font-bold text-gray-800">{expertProfile?.rating || 0}</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-emerald-100/50 rounded-xl p-4 border border-emerald-100">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-emerald-500/10 rounded-lg">
                  <FiDollarSign className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <p className="text-xs font-medium text-emerald-600">Rate</p>
                  <p className="text-lg font-bold text-gray-800">${expertProfile?.perHourCharge || 0}<span className="text-sm font-normal text-gray-500">/hr</span></p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-xl p-4 border border-purple-100">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-purple-500/10 rounded-lg">
                  <FiClock className="w-4 h-4 text-purple-600" />
                </div>
                <div>
                  <p className="text-xs font-medium text-purple-600">Experience</p>
                  <p className="text-lg font-bold text-gray-800">{expertProfile?.experience || 0}<span className="text-sm font-normal text-gray-500"> yrs</span></p>
                </div>
              </div>
            </div>
          </div>

          {/* Personal Details */}
          <div className="bg-gray-50/80 rounded-xl border border-gray-200 p-4 space-y-3">
            <h3 className="flex items-center gap-2 text-sm font-semibold text-gray-700">
              <FiUser className="w-4 h-4 text-[#715EFE]" />
              Personal Details
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiMail className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-[10px] font-medium text-gray-400">Email</p>
                  <p className="text-sm text-gray-700 truncate max-w-[150px]">{expertProfile?.email || 'N/A'}</p>
                </div>
              </div>
              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiAward className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-[10px] font-medium text-gray-400">Qualification</p>
                  <p className="text-sm text-gray-700 truncate max-w-[150px]">{expertProfile?.qualification || 'N/A'}</p>
                </div>
              </div>
              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiClock className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-[10px] font-medium text-gray-400">Working Since</p>
                  <p className="text-sm text-gray-700">{expertProfile?.workingFrom ? moment(expertProfile?.workingFrom).format('YYYY') : 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Bank & Payout Details */}
          <div className="bg-gray-50/80 rounded-xl border border-gray-200 p-4 space-y-3">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                <MdOutlineAccountBalance className="w-4 h-4 text-[#715EFE]" />
                Bank & Payout Details
              </h3>
              {expertProfile?.isStripeVerified ? (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
                  <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
                  Stripe Verified
                </span>
              ) : expertProfile?.isFlutterwaveVerified ? (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
                  <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
                  Flutterwave Verified
                </span>
              ) : (expertProfile?.bank_name || expertProfile?.account_number || ViewModalData?.bank_name || ViewModalData?.account_number) ? (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-full">
                  <FiClock className="w-3.5 h-3.5 text-amber-500" />
                  Pending Verification
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-200 rounded-full">
                  Not Provided
                </span>
              )}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <MdOutlineAccountBalance className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-gray-400">Bank Name</p>
                  <p className="text-sm font-medium text-gray-700 truncate">{expertProfile?.bank_name || ViewModalData?.bank_name || 'N/A'}</p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiUser className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-gray-400">Account Holder Name</p>
                  <p className="text-sm font-medium text-gray-700 truncate">{expertProfile?.account_holder_name || ViewModalData?.account_holder_name || 'N/A'}</p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiCreditCard className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-gray-400">Account Number</p>
                  <p className="text-sm font-mono font-medium text-gray-700 truncate">{expertProfile?.account_number || ViewModalData?.account_number || 'N/A'}</p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiHash className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-gray-400">Bank Code / IFSC</p>
                  <p className="text-sm font-mono font-medium text-gray-700 truncate">{expertProfile?.bank_code || ViewModalData?.bank_code || 'N/A'}</p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiGlobe className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-gray-400">Country</p>
                  <p className="text-sm font-medium text-gray-700 truncate">
                    {typeof (expertProfile?.country || ViewModalData?.country) === 'object'
                      ? (expertProfile?.country?.name || ViewModalData?.country?.name || expertProfile?.country?.shortName || ViewModalData?.country?.shortName || 'N/A')
                      : (expertProfile?.country || ViewModalData?.country || 'N/A')}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                <FiDollarSign className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-[10px] font-medium text-gray-400">Currency</p>
                  <p className="text-sm font-medium text-gray-700 uppercase truncate">{expertProfile?.currency || ViewModalData?.currency || 'N/A'}</p>
                </div>
              </div>

              {(expertProfile?.routing_number || ViewModalData?.routing_number) && (
                <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100">
                  <FiHash className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                  <div className="min-w-0">
                    <p className="text-[10px] font-medium text-gray-400">Routing Number</p>
                    <p className="text-sm font-mono font-medium text-gray-700 truncate">{expertProfile?.routing_number || ViewModalData?.routing_number}</p>
                  </div>
                </div>
              )}

              {(expertProfile?.stripeAccountId || ViewModalData?.stripeAccountId) && (
                <div className="flex items-start gap-2.5 p-2 bg-white rounded-lg border border-gray-100 sm:col-span-2 lg:col-span-3">
                  <FiShield className="w-4 h-4 text-[#715EFE] flex-shrink-0 mt-0.5" />
                  <div className="min-w-0">
                    <p className="text-[10px] font-medium text-gray-400">Stripe Account ID</p>
                    <p className="text-sm font-mono font-medium text-gray-700 truncate">{expertProfile?.stripeAccountId || ViewModalData?.stripeAccountId}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Batches Section */}
          {batches.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800">
                  <FiVideo className="w-5 h-5 text-[#715EFE]" />
                  Training Batches
                </h3>
                <span className="px-2.5 py-1 text-xs font-medium text-[#715EFE] bg-[#715EFE]/10 rounded-full">
                  {batches.length} {batches.length === 1 ? 'Batch' : 'Batches'}
                </span>
              </div>
              <div className="grid gap-4 md:grid-cols-2">
                {batches.map(batch => renderCard(batch, 'batch'))}
              </div>
            </div>
          )}

          {/* Books Section */}
          {books.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800">
                  <FiBook className="w-5 h-5 text-emerald-600" />
                  Books & Resources
                </h3>
                <span className="px-2.5 py-1 text-xs font-medium text-emerald-600 bg-emerald-50 rounded-full">
                  {books.length} {books.length === 1 ? 'Resource' : 'Resources'}
                </span>
              </div>
              <div className="grid gap-4 md:grid-cols-2">
                {books.map(book => renderCard(book, 'book'))}
              </div>
            </div>
          )}

          {/* Courses Section */}
          {courses.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800">
                  <FiBookOpen className="w-5 h-5 text-purple-600" />
                  Courses
                </h3>
                <span className="px-2.5 py-1 text-xs font-medium text-purple-600 bg-purple-50 rounded-full">
                  {courses.length} {courses.length === 1 ? 'Course' : 'Courses'}
                </span>
              </div>
              <div className="grid gap-4 md:grid-cols-2">
                {courses.map(course => renderCard(course, 'course'))}
              </div>
            </div>
          )}
        </div>
      </div>
      {renderVideoModal()}
    </div>
  )
}

export default ViewModal